/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountType {
    NORMAL = 'Normal',
    TEST = 'Test',
    EXTERNAL = 'External',
}
